// extracted by mini-css-extract-plugin
export var active = "_2v-9";
export var backButton = "_2v-8";
export var clone = "_2v-e";
export var collapseBar = "_2v-j";
export var collapseMode = "_2v-l";
export var collapsed = "_2v-n";
export var dragHandle = "_2v-c";
export var dropdownIcon = "_2v-g";
export var expanding = "_2v-m";
export var hidden = "_2v-w";
export var iconContainer = "_2v-p";
export var iconSwapper = "_2v-v";
export var navItem = "_2v-6";
export var navItemIcon = "_2v-f";
export var navProfile = "_2v-7";
export var notificationCountBadge = "_2v-i";
export var notificationDot = "_2v-q";
export var optionsContainer = "_2v-h";
export var primaryNav = "_2v-0";
export var primaryNavDivider = "_2v-u";
export var primaryNavResizeHandle = "_2v-2";
export var primaryNavResizing = "_2v-1";
export var primaryNavTabSection = "_2v-t";
export var primaryTab = "_2v-o";
export var primaryTabIconBox = "_2v-r";
export var secondaryNav = "_2v-3";
export var selected = "_2v-s";
export var settingsNav = "_2v-4";
export var settingsNavItems = "_2v-5";
export var show = "_2v-d";
export var sideNav = "_2v-k";
export var teamItem = "_2v-a";
export var userProfileItem = "_2v-b";